import React from "react";
import ToggleGroup from "../ToggleGroup";
import Stepper from "../Stepper";
import { formatPrice } from "../../../utils/formatPrice";
import { SHEET_EXTRA_LBS } from "../../../utils/sheetPricing";

const LB_INCHES = { 1.5: 7, 2: 8, 2.5: 9, 4: 10 };
const MIN_SLICE_PIECES = 10;

// base/fusion/special-fusion cakes: Format, Pieces, Cake Style (round/sheet),
// Sheet Size, Weight, and Layers - the only cake type that ever needs
// round-vs-sheet logic (see isSheetEligible() in cakeCatalog.js).
const StandardCakeOptions = ({
    product,
    selectedFormat,
    onFormatChange,
    availableFormats,
    piecesApply,
    selectedPieces,
    onPiecesChange,
    baseVariant,
    sheetEligible,
    cakeStyle,
    onCakeStyleChange,
    usingSheet,
    sheetSize,
    onSheetSizeChange,
    eggTypeLbRate,
    lbsApply,
    lbOptions,
    selectedLbs,
    onLbsChange,
    layersApply,
    selectedLayers,
    onLayersChange,
    MIN_LAYERS,
    MAX_LAYERS,
    effectiveLayerPrice,
}) => (
    <>
        <ToggleGroup
            label="Format"
            options={availableFormats}
            selected={selectedFormat}
            onSelect={onFormatChange}
            formatOption={(v) => (v === "full" ? (product.sheetOnly ? "Sheet Cake" : "Full Cake") : "Boxed Slice")}
        />
        {piecesApply && (
            <Stepper
                label="Pieces"
                value={selectedPieces}
                min={MIN_SLICE_PIECES}
                onChange={onPiecesChange}
                note={`Min ${MIN_SLICE_PIECES} pieces · ${formatPrice(baseVariant.price)} each`}
            />
        )}
        {sheetEligible && !product.sheetOnly && selectedFormat === "full" && (
            <ToggleGroup
                label="Cake Style"
                options={["round", "sheet"]}
                selected={cakeStyle}
                onSelect={onCakeStyleChange}
                formatOption={(v) => (v === "round" ? "Round Cake" : "Sheet Cake")}
            />
        )}
        {usingSheet && selectedFormat === "full" && (
            <ToggleGroup
                label="Sheet Size"
                options={["quarter", "half"]}
                selected={sheetSize}
                onSelect={onSheetSizeChange}
                formatOption={(v) => (v === "quarter"
                    ? 'Quarter Sheet (14" x 10")'
                    : `Half Sheet (19" x 14") (+${formatPrice(eggTypeLbRate * (SHEET_EXTRA_LBS.half - SHEET_EXTRA_LBS.quarter))})`)}
            />
        )}
        {lbsApply && (
            <ToggleGroup
                label="Weight"
                options={lbOptions}
                selected={selectedLbs}
                onSelect={onLbsChange}
                formatOption={(v) => (v === lbOptions[0]
                    ? `${v} lb (${LB_INCHES[v]}")`
                    : `${v} lb (${LB_INCHES[v]}") (+${formatPrice(eggTypeLbRate * (v - lbOptions[0]))})`)}
            />
        )}
        {layersApply && (
            <ToggleGroup
                label="Layers"
                options={Array.from({ length: MAX_LAYERS - MIN_LAYERS + 1 }, (_, i) => i + MIN_LAYERS)}
                selected={selectedLayers}
                onSelect={onLayersChange}
                formatOption={(v) => (v === MIN_LAYERS ? `${v} Layers` : `${v} Layers (+${formatPrice((v - MIN_LAYERS) * effectiveLayerPrice)})`)}
            />
        )}
    </>
);

export default StandardCakeOptions;
